import React from 'react';
import styled from 'styled-components';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

type ElementType = 'p' | 'div' | 'span';

export interface CondensedSmallProps {
  as?: ElementType;
  children?: React.ReactNode;
  className?: string;
  name?: string | null;
  maxLines?: number | null;
  /**
   * Breaks a word anywhere rather than only where it could. Without it a run with no space in it -
   * a url, a hash, a pasted token - is one unbreakable word: it cannot wrap, so it sets the width
   * of whatever holds it and spills out of it rather than filling the lines `maxLines` allows.
   *
   * Only read alongside `maxLines`, which is what draws the lines to be kept to.
   */
  maxLinesStrict?: boolean;
}

interface DivProps {
  as: ElementType;
  children: React.ReactNode;
  dataTest: string;
}

const Div = ({ as, children, dataTest }: DivProps) =>
  React.createElement(as, { dataTest }, children);

const StyledDiv = styled(Div)``;

export const CondensedSmall = ({
  as = 'div',
  children = null,
  className = '',
  name = null,
  maxLines = null,
  maxLinesStrict = false,
}: CondensedSmallProps) => (
  <StyledDiv
    as={as}
    className={AttrsHelper.formatClassname(
      'condensed-small',
      maxLines && `max-lines-${maxLinesStrict ? 'strict-' : ''}${maxLines}`,
      className
    )}
    data-test={name}
  >
    {children}
  </StyledDiv>
);
